// extracted by mini-css-extract-plugin
export default {"text":"Ry7m0Ohwgp3eLi2A2JTi"};